import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
import store from './store';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import http from './utils/http.1.js'
import global from "./utils/global";
import gciplayer from "./assets/thirdparty/gciplay.js";


Vue.prototype.HTTP = http
Vue.prototype.GLOBAL = global

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(VueQuillEditor);
Vue.use(ElementUI, {
    size: 'small'
});
const i18n = new VueI18n({
    locale: 'zh',
    messages
});

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} | 城投能源`;
    let token = sessionStorage.getItem('token');

	switch(to.path){

		case '/logout':
			localStorage.removeItem("sso-key");
			next('/login');
			break;
		case '/main':
		case '/loginform':
		case '/setPwd':
		case '/casLogin':
		case '/logout':
		case '/login':
			next();
			break;
		default:
			if(!token){
				next('/casLogin')
			}else{
				next()
			}
			break;
		
		
	}
	

	
	
	
	
	
	/* else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next() : next('/403');
    } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    } */
});

new Vue({
    router,
	store,
    i18n,
    render: h => h(App)
}).$mount('#app');
